import __var_0__ from './stdev.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Gamma distribution standard deviation.
*
* @module @stdlib/stats/base/dists/gamma/stdev
*
* @example
* var stdev = require( '@stdlib/stats/base/dists/gamma/stdev' );
*
* var v = stdev( 1.0, 1.0 );
* // returns 1.0
*
* v = stdev( 4.0, 12.0 );
* // returns ~0.167
*
* v = stdev( 8.0, 2.0 );
* // returns ~1.414
*/

// MODULES //
var stdev = __var_0__;


// EXPORTS //
export default stdev;
